import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'kmfc-notifications';
const MAX_NOTIFICATIONS = 50;

function load() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
}

function save(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_NOTIFICATIONS)));
}

export function addNotification({ type, title, message, orderId = null }) {
  const list = load();
  const notif = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type,
    title,
    message,
    orderId,
    timestamp: new Date().toISOString(),
    read: false,
  };
  save([notif, ...list]);
  window.dispatchEvent(new Event('kmfc-notifications-changed'));
}

export function useNotifications() {
  const [notifications, setNotifications] = useState(load);

  useEffect(() => {
    const sync = () => setNotifications(load());
    window.addEventListener('kmfc-notifications-changed', sync);
    return () => window.removeEventListener('kmfc-notifications-changed', sync);
  }, []);

  const markAllRead = useCallback(() => {
    const updated = load().map(n => ({ ...n, read: true }));
    save(updated);
    setNotifications(updated);
  }, []);

  const markRead = useCallback((id) => {
    const updated = load().map(n => n.id === id ? { ...n, read: true } : n);
    save(updated);
    setNotifications(updated);
  }, []);

  const clearAll = useCallback(() => {
    save([]);
    setNotifications([]);
  }, []);

  const unreadCount = notifications.filter(n => !n.read).length;

  return { notifications, unreadCount, markAllRead, markRead, clearAll };
}
